import angular, { IPromise, IWindowService } from "angular";
import {
  vsName as csvWriterServiceName,
  CsvWriter,
} from "../../../records/csv/csvWriter";
import { IQuery } from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ProgressivesContext } from "../model/progressivesContext";

export class DailyReadingsViewController {
  static $inject: string[] = [
    "progressivesContext",
    "$scope",
    "$q",
    csvWriterServiceName,
    "$http",
    ServerUtilityName,
    "$window",
  ];

  datePickerOpened: boolean = false;

  private readonly aggregate: IProgressiveAggregate = {
    completeMachineCount: 0,
    completeReadingCount: 0,
    liability: 0,
    machineCount: 0,
    readingCount: 0,
    liabilityChange: 0,
  };
  constructor(
    readonly progressivesContext: ProgressivesContext,
    $scope: angular.IScope,
    private readonly $q: angular.IQService,
    private readonly csvWriter: CsvWriter,
    private readonly $http: angular.IHttpService,
    private readonly serverUtility: ServerUtility,
    private readonly $window: IWindowService
  ) {
    this.defaultQueryChanged();
  }

  propertySelectionChanged() {
    this.progressivesContext.refreshSelectedProperties();
    this.defaultQueryChanged();
  }

  defaultQueryChanged(): IPromise<any[]> {
    return this.$q.all([
      this.updateJackpotAggregateInfo(),
      this.updateMachineAggregateInfo(),
    ]);
  }

  getReconciliationReport(): void {
    this.$http<Blob>({
      method: "get",
      url: "/api/machines/progressives/ProgressiveDailyPeriod/actions/GetReconciliationReport.csv",
      params: {
        Date: this.progressivesContext.date,
        PropertyIds: this.progressivesContext.selectedPropertyIds,
      },
      responseType: "blob",
    }).then((result) => {
      const blob = <Blob>(<any>result);
      this.csvWriter.saveFile({
        content: blob,
        filename: "Reconciliation Report.csv",
      });
    });
  }

  getPercentage(fraction: number, whole: number) {
    return Math.floor((fraction / whole) * 100.0);
  }

  private updateJackpotAggregateInfo(): angular.IPromise<void> {
    const completedCountTerm =
      "count(progressivedailyreadinggamelevelreadingidofrecord)";
    const totalCountTerm = "count(*)";
    const sumLiabilityTerm = "sum(liability)";
    const sumChangeTerm = "sum(change)";

    const query: IQuery = {
      ProgressiveDailyPeriodDate: this.progressivesContext.date,
      PropertyIds: this.progressivesContext.selectedPropertyIds,
      Take: 0,
      Include: `${totalCountTerm},${completedCountTerm},${sumLiabilityTerm},${sumChangeTerm}`,
    };

    return this.serverUtility
      .queryWrapped({
        url: "/api/machines/progressives/ProgressiveDailyReading/GameLevel",
        query,
      })
      .then((queryResponse) => {
        const meta = queryResponse.Meta;
        this.aggregate.completeReadingCount =
          Number.parseInt(meta[completedCountTerm]) || 0;
        this.aggregate.readingCount =
          Number.parseInt(meta[totalCountTerm]) || 0;
        this.aggregate.liability =
          Number.parseFloat(meta[sumLiabilityTerm]) || 0;
        this.aggregate.liabilityChange =
          Number.parseFloat(meta[sumChangeTerm]) || 0;
      });
  }

  private updateMachineAggregateInfo(): angular.IPromise<[void, void]> {
    const query: IQuery = {
      ProgressiveDailyPeriodDate: this.progressivesContext.date,
      PropertyIds: this.progressivesContext.selectedPropertyIds,
      Take: 0,
      Include: "count(*)",
    };

    const url = "/api/machines/progressives/ProgressiveDailyMachine";
    const totalCountPromise = this.serverUtility
      .queryWrapped({ url, query })
      .then((queryResponse) => {
        const meta = queryResponse.Meta;
        this.aggregate.machineCount = Number.parseInt(meta["count(*)"]) || 0;
      });

    const doneCountPromise = this.serverUtility
      .queryWrapped({
        url,
        query: {
          ...query,
          Complete: true,
        },
      })
      .then((queryResponse) => {
        this.aggregate.completeMachineCount = queryResponse.Total;
      });

    return this.$q.all([totalCountPromise, doneCountPromise]);
  }

  showDatepicker($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.datePickerOpened = true;
  }
}

interface IProgressiveAggregate {
  readingCount: number;
  machineCount: number;
  completeReadingCount: number;
  completeMachineCount: number;
  liability: number;
  liabilityChange: number;
}
